let formJson = {
  list: [
    {
      type: 'input',
      label: '输入框',
      options: {
        type: 'text',
        width: '100%',
        defaultValue: '',
        placeholder: '请输入',
        clearable: false,
        maxLength: null,
        addonBefore: '',
        addonAfter: '',
        hidden: false,
        disabled: false,
      },
      model: 'input_1697439125554',
      key: 'input_1697439125554',
      help: '',
      rules: [
        {
          required: false,
          message: '必填项',
        },
      ],
    },
    {
      type: 'number',
      label: '数字输入框',
      options: {
        width: '100%',
        defaultValue: 0,
        min: null,
        max: null,
        precision: null,
        step: 1,
        hidden: false,
        disabled: false,
        placeholder: '请输入',
      },
      model: 'number_1697439135121',
      key: 'number_1697439135121',
      help: '',
      rules: [
        {
          required: false,
          message: '必填项',
        },
      ],
    },
    {
      type: 'textarea',
      label: '文本框',
      options: {
        width: '100%',
        minRows: 4,
        maxRows: 6,
        maxLength: null,
        defaultValue: '',
        clearable: false,
        hidden: false,
        disabled: false,
        placeholder: '请输入',
      },
      model: 'textarea_1697439137753',
      key: 'textarea_1697439137753',
      help: '',
      rules: [
        {
          required: false,
          message: '必填项',
        },
      ],
    },
    {
      type: 'select',
      label: '下拉选择器',
      options: {
        width: '100%',
        multiple: false,
        disabled: false,
        clearable: false,
        hidden: false,
        placeholder: '请选择',
        dynamicKey: '用户列表',
        dynamic: false,
        options: [
          {
            value: '1',
            label: '下拉框1',
          },
          {
            value: '2',
            label: '下拉框2',
          },
        ],
        showSearch: false,
        dynamicInjectFuncToken: 'selectUser',
      },
      model: 'select_1697439140180',
      key: 'select_1697439140180',
      help: '',
      rules: [
        {
          required: false,
          message: '必填项',
        },
      ],
    },
    {
      type: 'slider',
      label: '滑动输入条',
      options: {
        width: '100%',
        defaultValue: 0,
        disabled: false,
        hidden: false,
        min: 0,
        max: 100,
        step: 1,
        showInput: false,
      },
      model: 'slider_1697443706341',
      key: 'slider_1697443706341',
      help: '',
      rules: [
        {
          required: false,
          message: '必填项',
        },
      ],
    },
    {
      type: 'switch',
      label: '开关',
      options: {
        defaultValue: false,
        hidden: false,
        disabled: false,
      },
      model: 'switch_1697443709619',
      key: 'switch_1697443709619',
      help: '',
      rules: [
        {
          required: false,
          message: '必填项',
        },
      ],
    },
    {
      type: 'alert',
      label: '警告提示',
      options: {
        type: 'success',
        description: '',
        showIcon: false,
        banner: false,
        hidden: false,
        closable: false,
      },
      key: 'alert_1697443713289',
    },
    {
      type: 'tabs',
      label: '标签页布局',
      options: {
        tabBarGutter: null,
        type: 'line',
        tabPosition: 'top',
        size: 'default',
        animated: true,
      },
      columns: [
        {
          value: '1',
          label: '选项1',
          list: [
            {
              type: 'number',
              label: '数字输入框',
              icon: 'icon-number',
              options: {
                width: '100%',
                defaultValue: 0,
                min: null,
                max: null,
                precision: null,
                step: 1,
                hidden: false,
                disabled: false,
                placeholder: '请输入',
              },
              model: 'number_1697443739017',
              key: 'number_1697443739017',
              help: '',
              rules: [
                {
                  required: false,
                  message: '必填项',
                },
              ],
            },
          ],
        },
        {
          value: '2',
          label: '选项2',
          list: [
            {
              type: 'input',
              label: '输入框',
              icon: 'icon-write',
              options: {
                type: 'text',
                width: '100%',
                defaultValue: '',
                placeholder: '请输入',
                clearable: false,
                maxLength: null,
                addonBefore: '',
                addonAfter: '',
                hidden: false,
                disabled: false,
              },
              model: 'input_1697443746201',
              key: 'input_1697443746201',
              help: '',
              rules: [
                {
                  required: false,
                  message: '必填项',
                },
              ],
            },
          ],
        },
      ],
      key: 'tabs_1697443723667',
    },
    {
      type: 'rate',
      label: '评分',
      options: {
        defaultValue: 0,
        max: 5,
        disabled: false,
        hidden: false,
        allowHalf: false,
      },
      model: 'rate_1697443716780',
      key: 'rate_1697443716780',
      help: '',
      rules: [
        {
          required: false,
          message: '必填项',
        },
      ],
    },
  ],
  config: {
    layout: 'horizontal',
    labelCol: {
      xs: 4,
      sm: 4,
      md: 4,
      lg: 4,
      xl: 4,
      xxl: 4,
    },
    labelWidth: 100,
    labelLayout: 'flex',
    wrapperCol: {
      xs: 18,
      sm: 18,
      md: 18,
      lg: 18,
      xl: 18,
      xxl: 18,
    },
    hideRequiredMark: false,
    customStyle: '',
    previewWidth: 800,
  },
};

let formVal = {};

export default {
  name: 'FcFormBuildCopy',
  data() {
    return {};
  },
  props: {
    value: {
      type: Object,
      default: () => formJson,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    outputString: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      type: Object,
      default: () => formVal,
    },
  },
  created() {
  },
  methods: {
    getData() {
      // 提交函数，提供父级组件调用
      return this.$refs.formBuildRef.getData();
    },
  },
  render() {
    const { value, disabled, defaultValue } = this;
    return (
      <div>
      </div>
    );
  },
};
